import { useQuery } from '@apollo/client/react';
import { usePathname } from 'next/navigation';
import { HiBellAlert } from 'react-icons/hi2';

import { PAGE_NAMES } from '~/shared/constants';
import { notificationUnreadCountQuery } from '~/shared/graphql-queries/notifications';
import { referralNotificationUnreadCountQuery } from '~/shared/graphql-queries/referral-notifications';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { checkIsClientsPanel } from '~/shared/helpers/check-helpers';

import './notifications-badge.scss';

const NotificationsBadge = ({ isAuthenticated, closeMenu, lng }) => {
  const pathname = usePathname();
  const isClientsPanel = checkIsClientsPanel(pathname);

  const unreadCountQuery = isClientsPanel ? referralNotificationUnreadCountQuery : notificationUnreadCountQuery;

  const { data: unreadCountData } = useQuery(unreadCountQuery, {
    skip: !isAuthenticated,
    fetchPolicy: 'cache-and-network',
    pollInterval: 30000,
  });

  const unreadCount = isClientsPanel
    ? unreadCountData?.referralNotificationUnreadCountQuery?.count
    : unreadCountData?.notificationUnreadCountQuery?.count;

  const unreadNotificationsCount = unreadCount > 99 ? '99+' : unreadCount;

  const notificationsHref = getLocaleLink(
    isClientsPanel ? PAGE_NAMES.CLIENTS_NOTIFICATIONS : PAGE_NAMES.PLATFORM_USER_NOTIFICATIONS,
    lng,
  );

  const onNotificationsClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    closeMenu && closeMenu();
    window.location.href = notificationsHref;
  };

  return (
    <div className="notifications-badge__notifications-badge-wrapper" onClick={onNotificationsClick}>
      <span className="notifications-badge__notifications--inner-badge-wrapper">
        <span className="notifications-badge__notifications-badge">
          <HiBellAlert color="#000000" size={12} />
        </span>

        <span className="notifications-badge__notifications-counter">{unreadNotificationsCount ?? 0}</span>
      </span>
    </div>
  );
};

export default NotificationsBadge;
